import React, { useState } from 'react'

// components
import SideViewModal from '../../../../components/modals/SideViewModal/SideViewModal.component'

// collections
import AddEquipment from '../AddEquipment.form'

// queries
import { useMutation } from '@apollo/client'
import { CREATE_EQUIPMENT } from '../../../../graphql/equipment/equipment.mutations'
import { GET_ALL_EQUIPMENT_WITH_FULL_DETAIL } from '../../../../graphql/equipment/equipment.queries'

// utils
import { validate } from '../../../../shared/utility'

const validationSchema = {
    sku: {
        type: 'input',
        validation: {
            required: true
        }
    },
    name: {
        type: 'input',
        validation: {
            required: true
        }
    },
    category: {
        type: 'input',
        validation: {
            required: true
        }
    },
    itemWeightInLbs: {
        type: 'input',
        validation: {
            required: true
        }
    },
    quantity: {
        type: 'input',
        validation: {
            required: true
        }
    }
}

export default function CreateEquipmentFormController({ visible, closeForm }) {
    const [createEquipment, {}] = useMutation(CREATE_EQUIPMENT)
    const [errors, setErrors] = useState({})

    const handleSubmit = (formData) => {
        const { isValid, errors } = validate(formData, validationSchema)
    
        if(isValid) {
            const submitData = {
                ...formData,
                quantity: parseInt(formData.quantity),
                itemWeightInLbs: parseFloat(formData.itemWeightInLbs),
                category: parseInt(formData.category)
            }
            
            createEquipment({ 
                variables: submitData, 
                refetchQueries:[GET_ALL_EQUIPMENT_WITH_FULL_DETAIL]
            }).catch(e => {
                console.error(e)
            }).then(result => {
                if(result) {
                    setErrors({})
                    closeForm()
                }
            })
        } else {
            setErrors(errors)
        }
    }

    if(visible) {
        const addVariants = [
            {
                name: 'Add Equipment',
                component: <AddEquipment />,
                stages: 1
            }
        ]

        return (<SideViewModal 
            show={visible} 
            submitText='Add Equipment'
            onSubmit={handleSubmit}
           onClose={() => {
                setErrors({})
                closeForm()
            }} 
            title='New Equipment'
            variants={addVariants}    
            errors={errors}
        />)
    }

    return null
}